var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      stroke: #000;\r\n      stroke-linecap: round;\r\n      stroke-linejoin: round;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.46,21.74h-19.2V2.54c0-.57-.46-1.04-1.04-1.04h-18.45c-.57,0-1.04.46-1.04,1.04v19.21H2.54c-.57,0-1.04.46-1.04,1.04v18.44c0,.57.46,1.04,1.04,1.04h19.21v19.21c0,.57.46,1.04,1.04,1.04h18.45c.57,0,1.04-.46,1.04-1.04v-19.21h19.2c.57,0,1.04-.46,1.04-1.04v-18.44c0-.57-.46-1.04-1.04-1.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacie);
export default __webpack_public_path__ + "static/media/pharmacie.bb7590af3a62ecbb9598311ef3447117.svg";
export { ForwardRef as ReactComponent };